import {
  addVendor,
  uploadDocumentAPI,
  getVendor,
  putVendor,
} from "../../utils/apiFunctions.js";
import {
  dynamicRules,
  getCustomFields,
  columnWidth,
  showError,
  validateField,
} from "../../utils/customFields";
import FormShimmer from "../../components/fixedcomponents/FormShimmer.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import InputField from "../../components/InputComponents/Input";
import CustomQuillEditor from "../../components/InputComponents/CustomQuillEditor";
import SelectCustom from "../../components/InputComponents/SelectCustom";
import MultiSelectCustom from "../../components/InputComponents/MultiSelectCustom";
import SwitchBox from "../../components/InputComponents/Switch";
import UploadDocument from "../../components/InputComponents/UploadDocument";
import FormTags from "../../components/InputComponents/FormTags";
import DateField from "../../components/InputComponents/DateField";
const vendorData = {
  name: "vendorMixin",
  data: () => ({
    LoaderStatus: false,
    activatelink: false,
    parentID: 4,
    customFieldsArray: [],
    newObject: {
      customFields: {},
    },
    validation: {},
    touchedFields: {},
    valText: {},
    shimmerLoader: false,
  }),
  components: {
    FormShimmer,
    Spinner,
    InputField,
    CustomQuillEditor,
    SelectCustom,
    MultiSelectCustom,
    SwitchBox,
    UploadDocument,
    FormTags,
    DateField,
  },
  async created() {
    this.shimmerLoader = true;
    if (
      this.$route.name == "EditVendor" ||
      this.$route.name == "ActivateVendor"
    ) {
      await this.getVendor();
    } else {
      await this.initializeData("add");
    }
  },
  methods: {
    async initializeData(type) {
      const response = await getCustomFields(this.parentID, type);
      if (response.length) {
        if (type == "add") {
          [this.customFieldsArray, this.newObject, this.touchedFields] =
            response;
        } else {
          [this.customFieldsArray, this.touchedFields] = response;
        }
        this.validations = dynamicRules(this.customFieldsArray);
        this.shimmerLoader = false;
      }
    },
    validateField(field) {
      return validateField(field, this);
    },
    getColumn(field) {
      return columnWidth(field);
    },
    getError(field) {
      return showError(field, this.touchedFields[field.key], this);
    },
    getVmodel(field) {
      return field.fieldType == "default"
        ? this.newObject[field.key]
        : this.newObject.customFields[field.key];
    },
    handleInput(field) {
      this.touchedFields[field.key] = true;
      this.$forceUpdate();
    },
    handleBlur(field) {
      if (this.touchedFields[field.key] && !this.validation[field.key]) {
        this.validateField(field, this);
        this.$forceUpdate();
      }
    },
    updateFieldValue(field, value) {
      if (field.fieldType === "default") {
        this.$set(this.newObject, field.key, value);
      } else {
        this.$set(this.newObject.customFields, field.key, value);
      }
      this.$forceUpdate();
      this.validateField(field, this);
    },
    validateForm() {
      let invalidForm = false;
      for (let i = 0; i < this.customFieldsArray.length; i++) {
        const field = this.customFieldsArray[i];
        this.touchedFields[field.key] = true;
        this.$forceUpdate();
        if (!this.validateField(field, this)) {
          invalidForm = true;
        }
      }
      if (!invalidForm) {
        if (this.$route.name == "AddVendor") {
          this.addVendor();
        } else {
          this.editVendor();
        }
      } else {
        this.errorModal("Please fill all details");
      }
    },
    async addVendor() {
      try {
        this.LoaderStatus = true;
        let anotherCust;
        anotherCust = JSON.parse(JSON.stringify(this.newObject));
        for (const field of this.customFieldsArray) {
          if (field.controlType === "upload_file") {
            if (field.fieldType === "default") {
              delete anotherCust[field.key];
            } else {
              delete anotherCust.customFields[field.key];
            }
          }
        }
        let payload = {
          customerType: this.parentID == 2 ? "1" : "2",
          ...anotherCust,
        };
        const res = await addVendor(payload);
        if (res.status == 200) {
          this.LoaderStatus = false;
          const form = new FormData();
          form.append("type", this.parentID);
          form.append("vendorID", res.data.data.Details);
          var attachment = [];
          for (const field of this.customFieldsArray) {
            const key =
              field.fieldType === "default"
                ? this.newObject[field.key]
                : this.newObject.customFields[field.key];
            if (field.controlType === "upload_file" && key) {
              let obj = {
                attachmentName: field.key,
              };
              attachment.push(obj);
              form.append(field.key, key);
            }
          }
          form.append("attachment", JSON.stringify(attachment));
          await uploadDocumentAPI(form);

          this.$router.push({
            name: "Manage",
            query: {
              status: this.$route.query.status,
              type: this.$route.query.type,
              sort: this.$route.query.sort,
            },
          });
          this.$nextTick(() => {
            this.successModal("New Vendor has been added.");
          });
          this.$nextTick(() => {
            this.successModal("New Vendor account has been created.");
          });
        } else if (res.status == 208) {
          this.LoaderStatus = false;
          this.vendorMessage = res.data.data.Detail;
          this.errorModal(`${this.vendorMessage}`);
        } else if (res.status == 409) {
          this.LoaderStatus = false;
          this.vendorMessage = res.data.data.Detail;
          this.errorModal(`${this.vendorMessage}`);
        } else {
          this.LoaderStatus = false;
          this.errorModal("Something went wrong!");
        }
      } catch (err) {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong!");
        throw err;
      }
    },
    gobackpointer() {
      this.$router.push({
        name: "Manage",
        query: {
          status: "manage",
          type: this.$route.query.type,
          sort: this.$route.query.sort,
        },
      });
    },
    gotoparticularvenddetails() {
      let type = 0;
      this.$router.push({
        path: `activatevendor/${this.selectedvendor.vendorID}/${type}`,
        query: {
          status: this.$route.query.status,
          type: this.$route.query.type,
          sort: this.$route.query.sort,
        },
      });
    },
    gotoparticularpage() {
      if (this.updateData == false) {
        this.LoaderStatus = false;
        this.$bvModal.show("inactivevendors");
      } else {
        this.LoaderStatus = false;
        this.updatebtn = true;
        this.$bvModal.hide("custsamename");
      }
    },
    async getVendor() {
      try {
        const response = await getVendor({
          type: this.$route.params.type,
          vendorID: this.$route.params.vendorID,
        });
        const { data } = response.data;
        this.newObject = data;
        this.initializeData("edit");
        this.LoaderStatus = false;
      } catch (error) {
        throw new Error(`get Vendor Failed! status: ${error.status}`);
      }
    },

    async editVendor() {
      try {
        if (
          this.$route.name == "ActivateVendor" &&
          this.$route.params.type == 0
        ) {
          this.newObject.active = true;
          this.activatelink = true;
        }
        this.LoaderStatus = true;
        let anotherCust;
        anotherCust = JSON.parse(JSON.stringify(this.newObject));
        for (const field of this.customFieldsArray) {
          if (field.controlType === "upload_file" && field.isReupload) {
            if (field.fieldType === "default") {
              delete anotherCust[field.key];
            } else {
              delete anotherCust.customFields[field.key];
            }
          }
        }
        let payload = {
          customerType: this.parentID == 2 ? "1" : "2",
          ...anotherCust,
        };
        const res = await putVendor(payload);
        if (res.status == 200) {
          // this.activatelink = true;
          this.LoaderStatus = false;
          const form = new FormData();
          form.append("type", this.parentID);
          form.append("vendorID", this.$route.params.vendorID);
          var attachment = [];
          for (const field of this.customFieldsArray) {
            const key =
              field.fieldType === "default"
                ? this.newObject[field.key]
                : this.newObject.customFields[field.key];
            if (
              field.controlType === "upload_file" &&
              field.isReupload &&
              key
            ) {
              let obj = {
                attachmentName: field.key,
              };
              attachment.push(obj);
              form.append(field.key, key);
            }
          }
          form.append("attachment", JSON.stringify(attachment));
          if (attachment.length !== 0) {
            await uploadDocumentAPI(form);
          }
          this.$router.push({
            name: "Manage",
            query: {
              status: this.$route.query.status,
              type: this.$route.query.type,
              sort: this.$route.query.sort,
            },
          });
          this.$nextTick(() => {
            if (this.activatelink) {
              this.successModal("Vendor has been activated.");
            } else {
              this.successModal("Vendor has been updated.");
            }
          });
        } else if (res.status == 208) {
          this.LoaderStatus = false;
          let errorMessage = res.data.data.Detail;
          this.errorModal(`${errorMessage}`);
        } else if (res.status == 409) {
          this.LoaderStatus = false;
          let errorMessage = res.data.data.Details;
          this.errorModal(`${errorMessage}`);
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (err) {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong!");
        throw err;
      }
    },
  },
};

export default vendorData;
